// src/App.jsx
import React from "react";  
import { BrowserRouter as Router } from "react-router-dom";
import Support from "./pages/Support";
import News from "./pages/News";
import Shop from "./pages/Shop";
import AlphaOne from "./pages/AlphaOne";
import MainNavbar from "./components/MainNavbar";
import HeroSection from "./components/HeroSection";
import Sections from "./components/Sections";
import Footer from "./components/Footer";
import Champions from "./pages/Champions";
import Media from "./pages/Media";
import { Routes, Route } from "react-router-dom";

const App = () => {
    return (
        <Router>
            <MainNavbar />
            <main>
                <Routes>
            <Route
                path="/"
                element={
                    <>
                        <HeroSection />
                        <Sections />
                    </>
                }
            />
            <Route path="/champions" element={<Champions />} />
            <Route path="/media" element={<Media />} />
            <Route path="/support" element={<Support />} />
            <Route path="/news" element={<News />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/alpha-one" element={<AlphaOne />} />
                </Routes>
            </main>
            <Footer />
        </Router>
    );
};

export default App;

